import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat } from '../../../../../../../utils/youtube-format-helper';
import { YoutubeShortsAdTvShellComponent } from './youtube-shorts-ad-tv-shell.component';

/**
 * Shorts ad for the 9:16 creative on the TV app: the native Shorts frame, a
 * tall strip against the copy column with the set's dark screen to its left.
 */
@Component({
    selector: 'app-gen-youtube-shorts-ad-tv-fullscreen',
    imports: [YoutubeShortsAdTvShellComponent],
    template: '<app-gen-youtube-shorts-ad-tv-shell [data]="data" [format]="format" />',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class YoutubeShortsAdTvFullscreenPreviewComponent {
  @Input() data!: GenVideoPreviewData;

  readonly format: VideoFormat = '9:16';
}
